import { render, staticRenderFns } from "./ProjetosForm.vue?vue&type=template&id=b48ef748&"
import script from "./ProjetosForm.vue?vue&type=script&lang=js&"
export * from "./ProjetosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports